export default __webpack_public_path__ + "static/media/it-check.d280a088.svg";